const pickerDateFormatter = new Intl.DateTimeFormat("en-US", { timeZone: "UTC" });

export const isoToPickerDate = (d: string): string => pickerDateFormatter.format(new Date(d));

export const pickerToIsoDate = (d: string): string => new Date(d).toISOString().split("T")[0];

export const todayAsIsoDate = new Date().toISOString().split("T")[0];

export const errorDetailToAlertText = (detail: string) => {
  const s = detail.split(" ");
  s.shift();
  return `Could not generate new docs: ${s.join(" ")}`;
};
